import React, {Component, Fragment} from "react";
import {
  Row,
  Col,
  InputGroup,
  Table,
  Button
} from "reactstrap";

import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import DatePicker from "react-datepicker";
import Collapsible from 'react-collapsible';
import "react-datepicker/dist/react-datepicker.css";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Moment from "react-moment";
import Pagination from "react-js-pagination";
import "react-confirm-alert/src/react-confirm-alert.css";

import ListCustomers from "./_ListCustomers"
import { BtnPermissions } from "../../lib/BtnPermissions"
import DisplayRecordText from "../controls/_DisplayRecordText"
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import ButtonExt from '../controls/ButtonExt'
import TrangThaiView from './_TrangThaiView'

import { currentDate, parseDatetime } from "../../lib/common";

// Import actions
import * as orderActions from '../MarketingOrder/actions'
import * as ordersAction from './actions'
import { storedb } from "../../views/client/storedb";
import Autocomplete from "../controls/_Autocomplete";

var dbContext;
class MarketingOrders extends Component {
  constructor(props) {
    super(props);

    dbContext = storedb();
    this.state = {
      searchCondition: {
        startDate: currentDate().startOf('month'),
        endDate: currentDate(),
        trangThai: "",
        keyword: '',
        Nvkd: [],
        type: 1,
        page: 1,
        per_page: 20,
        khachHang: "",
        DaiLy: "",
      },
      preFix: 'marketingOrders-',
      store_id: dbContext.getStoreId(),
      kho_id: dbContext.getKhoId(),
      khoIds: dbContext.getKhoIds(),
      listNvkd: [],
      listKhachHang: [],
      total_record: 0,
      total_amount: 0,
      modalListCustomer: false,
      addedCustomers: [],
      currentOrder: {}
    };

    this.addHoaDonClick = this.addHoaDonClick.bind(this);
  }
  checkTypeOrder = (callback) => {
    const params = this.props.match ? this.props.match.params : 1;
    if (params) {
      let {searchCondition} = this.state
      searchCondition.type = parseInt(params.type || 1)
      searchCondition.trangThai = parseInt(params.status)
      this.setState({ searchCondition }, callback)
    }
  }
  handleControlChange(name, e) {
    let { searchCondition } = this.state
    switch (name) {
      case "startDate":
        searchCondition.startDate = e
        break;
      case "endDate":
        searchCondition.endDate = e
        break;
      case "TrangThai":
        searchCondition.trangThai = e.target.value
        break;
      case "keyword":
        searchCondition.keyword = e.target.value
        break;
    }
    this.setState({ searchCondition });
  }
  onCustomerClearCLick = () => {
    this.onCustomerSelectChanged();
    this.onCustomerTextChanged("")
  }
  onCustomerTextChanged = (keyword, callback) => {
    const formData = {
      keyword: keyword || ""
    }
    this.props.loadCustomers(formData, (items) => {
      this.setState({
        listKhachHang: items
      }, () => {
        if (callback) {
          callback()
        }
      })
    });
  }
  onCustomerSelectChanged = (e) => {
    let {searchCondition} = this.state
    if (e) {
      searchCondition.khachHang = e.value
    } else {
      searchCondition.khachHang = ""
    }
    this.setState({
      searchCondition
    })
  }
  handlePageChange = pageNumber => {
    let {searchCondition} = this.state
    searchCondition.page = parseInt(pageNumber || 1);
    return this.setState({ searchCondition }, () => {
      this.fetchList(pageNumber, true)
    })
  }
  orderLinkDetails = (soHd) => {
    return `/marketing-order-view/${soHd}`
  }
  viewOrder = (e, soHd) => {
    e.preventDefault()
    const url = this.orderLinkDetails(soHd)
    this.props.history.push(url);
  };
  search = () => {
    if (this.props.orders.listRequesting) {
      return false;
    }

    let {searchCondition} = this.state
    searchCondition.page = 1
    return this.setState({ searchCondition }, () => {
      this.fetchList(1, true)
    });
  }
  viewCustomers = (order) => {
    const { viewAddedCustomers } = this.props
    const requestData =
    {
      orderId: order.Id
    }
    const callBack = (data) => {
      this.setState({
        addedCustomers: data,
        currentOrder: order,
        modalListCustomer: true,
      });
    }
    return viewAddedCustomers(requestData, callBack)
  }
  getListAddedCustomer = (orderId) => {
    const { viewAddedCustomers } = this.props
    const requestData =
      {
        orderId: orderId
      }
    const callBack = (data) => {
      this.setState({
        addedCustomers: data,
      });
    }
    return viewAddedCustomers(requestData, callBack)
  }
  getListNVKD() {
    const { ordersListNvRequest } = this.props
    const requestData =
    {
      store_id: this.state.store_id
    }
    const callBack = (data) => {
      this.setState({
        listNvkd: data
      });
    }
    return ordersListNvRequest(requestData, callBack)
  }
  buildSelectOptionNVKD(listNVKD) {
    var options = [];
    if (listNVKD && listNVKD.length > 0) {
      listNVKD.map((item) => { options.push({ value: item.Id, label: item.TenDayDu }) }
      );
    }
    return options;
  }
  buildSelectOptionDaiLy(listDL) {
    var options = [];
    if (listDL && listDL.length > 0) {
      listDL.map((item) => { options.push({ value: item.Id, label: item.Ten }) }
      );
    }
    return options;
  }
  fetchList = (page, useCached) => {
    const { ordersListRequest } = this.props
    const { searchCondition } = this.state
    const requestData =
    {
      store_id: this.state.store_id,
      type: searchCondition.type,
      quanLyId: this.getQuanLyIds(),
      khachHangId: searchCondition.khachHang,
      keyword: searchCondition.keyword,
      trangThai: searchCondition.trangThai,
      startDate: searchCondition.startDate.unix(),
      endDate: searchCondition.endDate.endOf('days').unix(),
      page: page || searchCondition.page,
      per_page: searchCondition.per_page,
      use_cached: useCached || false,
    }
    
    const callback = (item) => {
      searchCondition.page = item.page
      searchCondition.per_page = item.per_page
      this.setState(
        {
          searchCondition,
          total_record: item.total_record || 0,
          total_amount: item.total_amount || 0,
          page: item.page,
          per_page: item.per_page,
          list: item.records
        }
      )
    }
    return ordersListRequest(requestData, callback)
  }
  getQuanLyIds = () => {
    if (!this.state.searchCondition.Nvkd || this.state.searchCondition.Nvkd.length === 0) {
      return 0
    } else {
      return this.state.searchCondition.Nvkd[0].value
    }
  }
  exportXls = () => {
    const { ordersExportXlsRequest } = this.props
    const { searchCondition } = this.state
    var khId = '';
    if (searchCondition.type == 2) {
      khId = searchCondition.DaiLy
    } else {
      khId = searchCondition.khachHang
    }
    const requestData =
    {
      store_id: this.state.store_id,
      type: searchCondition.type,
      quanLyId: this.getQuanLyIds(),
      khachHangId: khId,
      keyword: searchCondition.keyword,
      trangThai: searchCondition.trangThai || '',
      startDate: searchCondition.startDate.unix(),
      endDate: searchCondition.endDate.endOf('days').unix(),
      page: 0,
      per_page: 0
    }
    const dialogSaveFile = (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "ds_dathang.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
    return ordersExportXlsRequest(requestData, dialogSaveFile)
  }
  onChangeItem = (itemPerPage) => {
    let {searchCondition} = this.state
    searchCondition.per_page = itemPerPage
    this.setState({ searchCondition }, () => {
      this.search();
    });
  }
  storeSearchCondition = () => {
    let {preFix, searchCondition} = this.state
    const key = `${preFix}${searchCondition.type}`
    let cached = JSON.stringify(searchCondition)
    sessionStorage.setItem(key, cached)
  }
  mergeSearchCondition = (type, callback) => {
    try {
      let {preFix, searchCondition} = this.state
      const key = `${preFix}${type}`
      const cached = sessionStorage.getItem(key)
      if (cached || cached != '') {
        let searchConditionCached = JSON.parse(cached)
        if (searchConditionCached) {
          searchCondition = {...searchCondition, ...searchConditionCached}
          searchCondition.startDate = parseDatetime(searchCondition.startDate)
          searchCondition.endDate = parseDatetime(searchCondition.endDate)
        }
      }
      this.setState({searchCondition}, callback)
    } catch (error) {
      console.log(error)
      callback()
    }
  }
  initData = () => {
    this.mergeSearchCondition(this.state.searchCondition.type, () => {
      this.getListNVKD()
      this.fetchList(1, true)
    })
  }
  componentDidMount() {
    this.checkTypeOrder(this.initData)
  }
  componentWillUnmount() {
    this.storeSearchCondition()
  }
  componentWillReceiveProps(nextProps) {
    let { searchCondition } = this.state
    const { match: { params } } = nextProps
    if (params.status != this.props.match.params.status || 
      params.type != this.props.match.params.type) {
      searchCondition.trangThai = parseInt(params.status)
      searchCondition.type = parseInt(params.type || 1)
      this.setState({ searchCondition }, () => {
        this.initData()
      });
    }
  }
  addHoaDonClick = () => {
    this.props.history.push("/marketing-order");
  }
  processOrderClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Tiếp nhận xử lý đơn hàng <b className="text-danger">{item.MaDonHang}</b> này không?
            </p>
            <button className="text-danger" onClick={() => {
              const formData = {
                store_id: item.StoreId,
                order_id: item.Id
              }
              const onSuccess = () => {
                setTimeout(this.fetchList, 1000)
              }
              this.props.processOrder(formData, onSuccess)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  toggleViewCustomers = e => {
    if (!this.state.modalListCustomer) {
      this.setState(() => ({
        modalListCustomer: true,
      }));
    }
    else {
      //close 
      this.setState(() => ({
        modalListCustomer: false,
        addedCustomers: [],
        currentOrder: {}
      }));
    }
  }
  onHandleRemove = () => {
    let {searchCondition} = this.state
    searchCondition.Nvkd = []
    this.setState({ searchCondition })
  }
  onHandleChoice = (nodesChecked) => {
    let {searchCondition} = this.state
    searchCondition.Nvkd = nodesChecked
    this.setState({ searchCondition })
  }
  sendClick = (order, customer) => {
    const formData = {
      order_id: order.Id,
      customer_ids: [customer.Id]
    }
    const onSuccess = ({code, message}) => {
      const key = order.Id + customer.Id
      if (code != 200) {
        dbContext.addAlert({key, text: message, type: "error"})
      } else {
        this.getListAddedCustomer(order.Id)
        dbContext.addAlert({key, text: message, type: "success"})
      }
    }
    this.props.sendOrder(formData, onSuccess);
  }
  formatOptionLabel = (option) => {
    return (
      <div className="item">
        <div>{option.label}</div>
        <span className={"text-mute item_unit"}>{'\u00A0'}{option.diaChi}</span>
      </div>
    )
  }
  formatNoOptionLabel = (input) => {
    return (
      <Fragment>
        <em>Không tìm khách hàng <i className="text-danger">#{input}</i></em>
      </Fragment>
    )
  }
  render() {
    const { 
      list, 
      khoIds,
      searchCondition,
    } = this.state
    const {
      orders: {
        listRequesting,
      },
    } = this.props
    const startIndex = (searchCondition.page > 0 ? searchCondition.page - 1 : 0) * searchCondition.per_page
    const mapToCustomers = (items) => {
      return (items || []).map((item) => {
        let label = item.Ten
        if (item.Ma && item.Ma !== '') {
          label += `/${item.Ma}`
        }
        return {
          label: label,
          value: item.Id,
          dienThoai: item.DienThoai,
          diaChi: item.DiaChi,
          ref: item,
        }
      })
    }
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting}>
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                <Col sm="4" xs="6" md="2" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker
                      name="startDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Từ ngày"
                      selected={searchCondition.startDate}
                      onChange={this.handleControlChange.bind(
                        this,
                        "startDate"
                      )}
                      required
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="2" className="mb-1  pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker
                      name="endDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Đến ngày"
                      selected={searchCondition.endDate}
                      popperClassName="react-end-date"
                      popperPlacement="top-end"
                      onChange={this.handleControlChange.bind(
                        this,
                        "endDate"
                      )}
                      required
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                  <CheckboxTreeList
                    placeholder={`--Nhân viên KD--`}
                    nodes={this.state.listNvkd}
                    checked={searchCondition.Nvkd}
                    isMultiChoice={false}
                    onHandleRemove={(item) => this.onHandleRemove(item)}
                    onChoice={e => this.onHandleChoice(e)}
                  />
                </Col>
                <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                  <Autocomplete
                    name="customer"
                    placeholder="Tên khách hàng, số điện thoại"
                    setFocus={false}
                    selectOnTab={true}
                    tabIndex={4}
                    formatOptionLabel={this.formatOptionLabel}
                    formatNoOptionLabel={this.formatNoOptionLabel}
                    handleClearClick={this.onCustomerClearCLick}
                    handleChange={this.onCustomerTextChanged}
                    onSelection={this.onCustomerSelectChanged}
                    suggestions={mapToCustomers(this.state.listKhachHang)}
                  />
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="mr-1 pull-left" onClick={this.search}>
                <i className="fa fa-search" /> Tìm kiếm
              </Button>
              <ButtonExt size="md" btnClass="pull-left mr-1 mb-1" btnClick={this.addHoaDonClick}
                iconClass="fa-plus" displayText="Thêm đơn" color="primary"
                permission={BtnPermissions.DonHang.SAVE_ORDER} />
              <div className="clearfix"></div>
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="30" className="text-center table-border-right">#</th>
                    <th scope="col" width="150" className="text-center table-border-right">Mã đơn hàng</th>
                    <th scope="col" width="80" className="text-center table-border-right">Nhà thuốc</th>
                    <th scope="col" width="100" className="text-center table-border-right">Ngày lập</th>
                    <th scope="col" width="120" className="text-center table-border-right">Nhân viên KD</th>
                    <th scope="col" width="110" className="text-center table-border-right">Nơi xuất</th>
                    <th scope="col" width="100" className="text-right table-border-right">Tổng tiền	</th>
                    <th scope="col" className="text-center table-border-right">Ghi chú</th>
                    <th scope="col" width="100" className="text-center table-border-right">Trạng thái</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center table-border-right">{startIndex + (idx + 1)}</td>
                        <td className="text-center table-border-right"><a href={`/#${this.orderLinkDetails(res.Id)}`} onClick={(e) => this.viewOrder(e, res.Id)}>{res.MaDonHang}</a> </td>
                        <td className="text-center table-border-right">
                          <ButtonExt 
                            size="xs" btnClass="pull-right mr-1" btnClick={() => this.viewCustomers(res)}
                            iconClass="fa-eye" displayText="Xem" color="primary" 
                            permission={""} />
                        </td>
                        <td className="text-center table-border-right">{res.NgayLap && <Moment format="HH:mm DD/MM">{`${res.NgayLap}`}</Moment>}</td>
                        <td className="text-center table-border-right">{res.TenNhanVien}</td>
                        <td className="text-center table-border-right">{res.NoiXuat}</td>
                        <td className="text-right text-danger font-weight-bold table-border-right">{parseFloat(res.TongTien || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-left table-border-right">{res.GhiChu}</td>
                        <td className="table-border-right text-center">
                          <TrangThaiView
                            order={res}
                            processOrderClick={this.processOrderClick}
                            chkApproveCLick={this.chkApproveCLick}
                            khoIds={khoIds}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="8" className="text-right">
                      Tổng Tiền:&nbsp;
                     <span className="text-success">
                        {this.state.total_amount &&
                          this.state.total_amount.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" colSpan="3" className="text-right">
                    </th>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <nav>
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total_record}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </nav>
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          <ListCustomers 
            customers={this.state.addedCustomers}
            order={this.state.currentOrder}
            isOpen={this.state.modalListCustomer}
            onClose={e => this.toggleViewCustomers(e)}
            onSendClick={this.sendClick}
          />
        </BlockUi>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  orders: state.marketingOrders,
  client: state.client
});

const connected = connect(
  mapStateToProps,
  {
    ordersListRequest: ordersAction.ordersListRequest,
    ordersKhachHangRequest: ordersAction.ordersKhachHangRequest,
    viewAddedCustomers: ordersAction.viewAddedCustomers,
    ordersListNvRequest: ordersAction.ordersListNvRequest,
    ordersDaiLyRequest: ordersAction.ordersDaiLyRequest,
    ordersExportXlsRequest: ordersAction.ordersExportXlsRequest,
    setOrdersApproveList: ordersAction.setOrdersApproveList,
    postApproveOrders: ordersAction.postApproveOrders,
    setApproveError: ordersAction.setApproveError,
    setApproveMessage: ordersAction.setApproveMessage,
    setCallbackFunc: orderActions.setCallbackFunc,
    sendOrder: orderActions.sendOrder,
    loadCustomers: orderActions.loadCustomers,
  }
)(MarketingOrders);

const formed = reduxForm({
  form: "marketingOrders"
})(connected);

export default formed;



// WEBPACK FOOTER //
// ./src/views/MarketingOrders/MarketingOrders.js